module.exports = __webpack_public_path__ + "img/logo_color.e08cf181.svg";